module.exports = __webpack_public_path__ + "static/media/gold_medal_icon.4afd42cc.svg";